import React, { useState, useEffect, useRef } from "react";
import TextField from "@mui/material/TextField";
import { useForm, Controller } from "react-hook-form";
import Grid from "@mui/material/Grid";
import Cookies from "universal-cookie";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import { VehicleInfo } from "@/_helpers";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getVehicleMakes } from "../../_api/vehicleApi";
import { enrolleeService } from "@/_services";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import KeylessStart from "../../../src/_images/KeylessStart.png";
import RemoteStart from "../../../src/_images/RemoteStart.png";
import HelpIcon from "@mui/icons-material/Help";
import {
  loadVehicle,
  loadVehicleTrim,
} from "../../_redux/actions/vehicleActions";
import { styled, useTheme } from "@mui/material/styles";
import { GridLoader } from "react-spinners";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import { brandColors } from "../../_components/brandedComponent/BrandedColors";
import { LifeSafer } from "../../_helpers/BrandConstants";
import ContinueButton from "./ContinueButton";
import CloseIcon from "@mui/icons-material/Close";
import { langConversionHelper } from "../../_helpers/langConversionHelper";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useParams } from "react-router-dom";
import { useDeviceTypeWatcher } from "@/_helpers/PhoneNumberHelper";
import { useToaster } from "../toaster/MuiToasterProvider";
import { getRegionId, getRegions } from "../../_api/dataListApi";

const VehicleInfos = ({
  loadVehicle,
  vehicleList,
  handleUpdate,
  // goToNextStep,
  goToBackStep,
  submitting,
  loadVehicleTrim,
  deviceType,
}) => {
  const cookies = new Cookies();
  const { t, i18n } = useTranslation();
  const toast = useToaster();
  const isMountedRef = useRef(null);
  const theme = useTheme();
  const [currentMakeId, setCurrentMakeId] = useState();
  const [vehicleMakesList, setVehicleMakesList] = useState([]);
  const [vehModelList, setVehModelList] = useState([]);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showNewVehicleEntry, setShowNewVehicleEntry] = useState(false);
  const [showTooltipRemote, setShowTooltipRemote] = useState(false);
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  const [checkedPush, setCheckedPush] = useState(false);
  const [checkedRemote, setCheckedRemote] = useState(false);
  const [showCrossButton, setShowCrossButton] = useState(false);
  const [showCrossButtonRemote, setShowCrossButtonRemote] = useState(false);
  // const engineClass = VehicleInfo.EngineClassList();
  const engineClass = langConversionHelper.engineClassList(
    i18n.language.slice(0, 2),
  );
  const enrolleeUser = JSON.parse(sessionStorage.getItem("enrolleeUser"));
  const [clientLoad, setClientLoad] = useState(false);
  const [vehicleValue, setVehicleValue] = useState("New Vehicle");
  const filterEngineClass = engineClass?.filter((item) => item?.code !== 4);
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const isSpeedStory =
    enrolleeUser?.story?.toLowerCase() === "speed" ||
    enrolleeUser?.story?.toLowerCase() === "isa volunteer";
  const isScheduleStory =
    enrolleeUser?.story?.toLowerCase() === "schedule now" ||
    enrolleeUser?.story?.toLowerCase() === "schedule";
  const { isISA } = useDeviceTypeWatcher();
  const { storyName } = useParams();
  const isEuropeStory = storyName?.toLowerCase() === "europe";
  const selectedLocationDeviceType = String(
    deviceType || enrolleeUser?.deviceType || enrolleeUser?.DeviceType || "",
  ).toLowerCase();
  const isLocationISA =
    storyName?.toLowerCase() === "location" &&
    ["isa", "speed", "speedv"].includes(selectedLocationDeviceType);
  const isISAVehicle =
    storyName?.toLowerCase() === "location" ? isLocationISA : isISA;
  const vehicleFieldSize = isEuropeStory ? { xs: 12, md: 6 } : 6;

  // const isISA =
  //   enrolleeUser?.clientTypeId === 6 ||
  //   enrolleeUser?.deviceType?.toLowerCase() === "speed" ||
  //   enrolleeUser?.deviceType?.toLowerCase() === "isa";
  const vehicleYearList = VehicleInfo?.yearList(isISAVehicle) || [];
  // const [showStart, setShowStart] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down(1005));
  const [selectedVehicleModel, setSelectedVehicleModel] = useState(null);
  const [vehicleTrimLists, setVehicleTrimLists] = useState([]);
  const [europeRegistrationCountries, setEuropeRegistrationCountries] =
    useState([]);
  const [registrationCountriesLoading, setRegistrationCountriesLoading] =
    useState(false);
  const CreditBox = styled(Grid)(() => ({
    minHeight: "100px",
    width: "300px",
    maxHeight: "160px",
  }));

  useEffect(() => {
    const mql = window.matchMedia("(pointer: coarse)");

    const checkDevice = () => setIsTouchDevice(mql.matches);
    checkDevice();

    mql.addEventListener("change", checkDevice);
    return () => mql.removeEventListener("change", checkDevice);
  }, []);

  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      vehYear: isEuropeStory
        ? vehicleYearList.find(
            (year) => String(year.code) === String(enrolleeUser?.vehYear),
          ) || null
        : null,
      vehMake: null,
      vehModel: null,
      engineClassId: isEuropeStory
        ? filterEngineClass.find(
            (engine) =>
              String(engine.code) === String(enrolleeUser?.engineClassId),
          ) || null
        : null,
      vehTrim: null,
      issuingCountry: null,
      licensePlate:
        enrolleeUser?.licensePlate === "CE - NEED"
          ? ""
          : enrolleeUser?.licensePlate || "",
    },
  });

  useEffect(() => {
    if (!isEuropeStory) return undefined;

    let isActive = true;
    setRegistrationCountriesLoading(true);

    getRegionId({ regionTypeId: 7, description: "European Union" })
      .then((region) => {
        const regionId =
          typeof region === "number"
            ? region
            : (region?.regionId ?? region?.RegionId);

        if (!regionId) {
          throw new Error("European Union region ID was not returned.");
        }
        return getRegions(regionId);
      })
      .then((regionsResponse) => {
        if (!isActive) return;

        const regions = Array.isArray(regionsResponse)
          ? regionsResponse
          : (regionsResponse?.countries ?? regionsResponse?.Countries ?? []);
        const countries = regions
          .map((region) => ({
            label: region?.description ?? region?.Description ?? "",
            code: region?.code ?? region?.Code ?? "",
            countryId: region?.countryId ?? region?.CountryId,
            regionId: region?.regionId ?? region?.RegionId,
          }))
          .filter((country) => country.label && country.regionId)
          .sort((first, second) => first.label.localeCompare(second.label));

        setEuropeRegistrationCountries(countries);

        const savedIssuingCountry = String(
          enrolleeUser?.issuingState ?? enrolleeUser?.IssuingState ?? "",
        ).toLowerCase();
        const matchedCountry = countries.find(
          (country) =>
            country.label.toLowerCase() === savedIssuingCountry ||
            country.code.toLowerCase() === savedIssuingCountry,
        );
        if (matchedCountry) setValue("issuingCountry", matchedCountry);
      })
      .catch((error) => {
        if (isActive) {
          setEuropeRegistrationCountries([]);
          console.error("Loading registration countries failed", error);
        }
      })
      .finally(() => {
        if (isActive) setRegistrationCountriesLoading(false);
      });

    return () => {
      isActive = false;
    };
  }, [isEuropeStory]);

  const handleChange = (event) => {
    setVehicleValue(event.target.value);
  };

  const onSubmit = (data) => {
    let newData = {
      userId: enrolleeUser?.userId,
      clientId: enrolleeUser?.clientId,
      make: data?.vehMake?.label,
      model: data?.vehModel?.vehicleModelName,
      vehYear: data?.vehYear?.code,
      remoteStart: checkedRemote,
      pushStart: checkedPush,
      engineClassId: data?.engineClassId?.code,
      vin: "CE - NEED VIN",
      licensePlate: isEuropeStory ? data?.licensePlate : null,
      issuingState: isEuropeStory
        ? data?.issuingCountry?.code || data?.issuingCountry || null
        : null,
      color: "",
      vehicleTrimId: data?.vehTrim?.vehicleTrimID || 3,
      Step: "Vehicle",
    };
    handleUpdate("Vehicle", newData);
  };

  const onInvalid = () => {
    if (!isEuropeStory) return;
    toast.error(
      t(
        "europe.completeRequiredFields",
        "Please complete all required fields before continuing.",
      ),
    );
  };

  const handleOpenTooltip = () => {
    setShowCrossButton(true);
    setShowTooltip((prev) => !prev);
  };
  const handleOpenRemoteTooltip = () => {
    setShowCrossButtonRemote(true);
    setShowTooltipRemote((prev) => !prev);
  };

  useEffect(() => {
    isMountedRef.current = true;
    getVehicleMakes()
      .then((makes) => {
        let transformed = makes.map((item) => {
          return { label: item.description, code: item.vehicleMakeId };
        });
        transformed.sort((a, b) => a.label.localeCompare(b.label));
        if (transformed.length > 0) {
          let filteredData = transformed.filter((x) => x.label !== "");
          setVehicleMakesList(filteredData);
        }
      })
      .catch((error) => console.error(error));
    return () => (isMountedRef.current = false);
  }, []);

  useEffect(() => {
    if (!isEuropeStory) return;
    setCheckedPush(Boolean(enrolleeUser?.pushStart));
    setCheckedRemote(Boolean(enrolleeUser?.remoteStart));
  }, [isEuropeStory]);

  useEffect(() => {
    if (!isEuropeStory || getValues("vehMake") || !vehicleMakesList.length) {
      return;
    }

    const savedMake = vehicleMakesList.find(
      (make) => make.label?.toLowerCase() === enrolleeUser?.make?.toLowerCase(),
    );
    if (savedMake) {
      setValue("vehMake", savedMake);
      setCurrentMakeId(savedMake.code);
    }
  }, [isEuropeStory, vehicleMakesList]);

  useEffect(() => {
    isMountedRef.current = true;
    if (isMountedRef.current && currentMakeId !== undefined) {
      enrolleeService
        .loadVehicleModels(currentMakeId)
        .then((data) => {
          setVehModelList(data);
        })
        .catch((error) => {
          console.log("Loading models failed! " + error);
        });
    }
    return () => (isMountedRef.current = false);
  }, [currentMakeId]);

  useEffect(() => {
    if (!isEuropeStory || getValues("vehModel") || !vehModelList.length) {
      return;
    }

    const savedModel = vehModelList.find(
      (model) =>
        model.vehicleModelName?.toLowerCase() ===
        enrolleeUser?.model?.toLowerCase(),
    );
    if (savedModel) {
      setValue("vehModel", savedModel);
      setSelectedVehicleModel(savedModel);
    }
  }, [isEuropeStory, vehModelList]);

  useEffect(() => {
    isMountedRef.current = true;
    if (isMountedRef.current && enrolleeUser !== undefined) {
      setClientLoad(true);
      loadVehicle(enrolleeUser?.clientId, enrolleeUser?.userId)
        .then((data) => {
          if (data?.length > 0) {
            setShowNewVehicleEntry(true);
          }
        })
        .catch((error) => {
          console.log("Loading failed! " + error);
        })
        .finally(() => {
          setClientLoad(false);
        });
    }
    return () => (isMountedRef.current = false);
  }, []);

  // useEffect(() => {
  //   if (
  //     (enrolleeUser?.clientTypeId && enrolleeUser?.clientTypeId !== 6) ||
  //     enrolleeUser?.deviceType?.toLowerCase() !== "speed" ||
  //     !isISA
  //   ) {
  //     setShowStart(true);
  //   } else {
  //     setShowStart(false);
  //   }
  // }, [enrolleeUser, isISA]);

  useEffect(() => {
    const fetchVehicleTrims = async () => {
      if (!selectedVehicleModel?.vehicleModelId || !isISAVehicle) return;

      const vehicleTrims = await loadVehicleTrim(
        selectedVehicleModel.vehicleModelId,
      );
      // const vehicleTrims = await loadVehicleTrim(91);
      setVehicleTrimLists(vehicleTrims);
    };

    fetchVehicleTrims();
  }, [selectedVehicleModel, isISAVehicle]);

  useEffect(() => {
    if (!isEuropeStory || getValues("vehTrim") || !vehicleTrimLists.length) {
      return;
    }

    const savedTrimId =
      enrolleeUser?.vehicleTrimId ?? enrolleeUser?.vehicleTrimID;
    const savedTrim = vehicleTrimLists.find(
      (trim) => String(trim.vehicleTrimID) === String(savedTrimId),
    );
    if (savedTrim) setValue("vehTrim", savedTrim);
  }, [isEuropeStory, vehicleTrimLists]);

  useEffect(() => {
    if (!isEuropeStory) return;
    const selectedEngine = getValues("engineClassId");
    if (!selectedEngine) return;
    const translatedEngine = filterEngineClass.find(
      (engine) => engine.code === selectedEngine.code,
    );
    if (translatedEngine) setValue("engineClassId", translatedEngine);
  }, [i18n.language, isEuropeStory]);

  const vehicleSelected = () => {
    if (vehicleValue !== "New Vehicle") {
      const selectedVehicle = vehicleList?.find(
        (x) => String(x?.vehicleId) === String(vehicleValue),
      );

      if (!selectedVehicle) return;

      const currentSessionEnrollee =
        JSON.parse(sessionStorage.getItem("enrolleeUser")) ||
        enrolleeUser ||
        {};
      const vehicleWithoutUserId = { ...selectedVehicle };
      delete vehicleWithoutUserId.userId;

      sessionStorage.setItem(
        "enrolleeUser",
        JSON.stringify({
          ...currentSessionEnrollee,
          ...vehicleWithoutUserId,
          vehicleId: selectedVehicle.vehicleId,
          VehicleId: selectedVehicle.vehicleId,
          VehicleID: selectedVehicle.vehicleId,
          selectedVehicleID: selectedVehicle.vehicleId,
          step: "Vehicle",
          Step: "Vehicle",
        }),
      );

      const instApptData = cookies.get("lifesaferInstallApt");
      const newData = {
        ...instApptData,
        selectedVehicleID: selectedVehicle.vehicleId,
      };
      cookies.set("lifesaferInstallApt", newData, {
        path: "/",
        sameSite: "strict",
      });
      // goToNextStep();
      handleUpdate("Vehicle", undefined, {
        ...vehicleWithoutUserId,
        vehicleId: selectedVehicle.vehicleId,
        selectedVehicleID: selectedVehicle.vehicleId,
        Step: "Vehicle",
      });
    } else {
      reset({
        vehYear: null,
        vehMake: null,
        vehModel: null,
        engineClassId: null,
        vehTrim: null,
        issuingCountry: null,
        licensePlate: "",
      });
      setCurrentMakeId(undefined);
      setVehModelList([]);
      setSelectedVehicleModel(null);
      setVehicleTrimLists([]);
      setCheckedPush(false);
      setCheckedRemote(false);
      setShowNewVehicleEntry(false);
    }
  };

  if (clientLoad) {
    return (
      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
        }}
      >
        <Grid>
          <GridLoader />
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      {showNewVehicleEntry ? (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flexGrow: 1,
              alignItems: "center",
              justifyContent: "center",
              mx: "auto",
            }}
          >
            <Grid
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <CreditBox
                style={{
                  padding: 10,
                  marginTop: 15,
                  border: `1px solid ${brandColors[brand].primary}`,
                  borderRadius: 5,
                }}
              >
                <Grid
                  container
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography sx={{ textAlign: "center", fontWeight: "500" }}>
                    {t("steps.vehiclePresentMessage")}
                  </Typography>
                </Grid>
              </CreditBox>
            </Grid>

            <Grid
              container
              direction="column"
              justifyContent="center"
              sx={{ mt: 1 }}
            >
              <Grid>
                <FormControl>
                  <RadioGroup value={vehicleValue} onChange={handleChange}>
                    {vehicleList !== undefined &&
                    vehicleList.CurrentState !== "Undefined" &&
                    vehicleList[0].CurrentState !== "None" ? (
                      vehicleList.map((veh) => {
                        let vehLabel = "";
                        let sVehYear = "";
                        if (veh.vehYear !== undefined && veh.vehYear !== null)
                          sVehYear = veh?.vehYear?.toString();
                        vehLabel = sVehYear + " " + veh.make + " " + veh.model;
                        return (
                          <FormControlLabel
                            key={veh?.vehicleId}
                            value={veh?.vehicleId?.toString()}
                            control={<Radio />}
                            label={vehLabel}
                          />
                        );
                      })
                    ) : (
                      <></>
                    )}
                    <FormControlLabel
                      value="New Vehicle"
                      control={<Radio />}
                      label={t("steps.newVehicle")}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid
                container
                justifyContent="center"
                style={{ paddingTop: 10 }}
              >
                <Grid>
                  <Button
                    size="medium"
                    variant="contained"
                    color="primary"
                    onClick={() => vehicleSelected()}
                  >
                    {t("steps.select")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </>
      ) : (
        <form
          className="form"
          onSubmit={handleSubmit(onSubmit, onInvalid)}
          style={{
            width: "100%",
            marginBottom: "40px",
            display: "flex",
            justifyContent: "center",
            maxWidth: "900px",
          }}
        >
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            sx={{
              width: "100%",
              marginTop: "25px",
            }}
            spacing="25px"
          >
            <Grid
              style={{ maxWidth: "300px", width: "100%" }}
              size={vehicleFieldSize}
            >
              <Controller
                name="vehYear"
                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    id="vehYear"
                    style={{ maxWidth: 300, width: "100%" }}
                    options={vehicleYearList}
                    getOptionLabel={(option) =>
                      option.label ? option.label : ""
                    }
                    isOptionEqualToValue={(option, value) =>
                      value.code === option.code
                    }
                    onChange={(_, data) => {
                      field.onChange(data);
                    }}
                    disabled={submitting}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("body.vehYearLabel")}
                        placeholder={t("body.selectVehYearLabel")}
                        variant="outlined"
                        error={!!errors.vehYear}
                        size="small"
                        helperText={
                          errors.vehYear ? errors.vehYear.message : ""
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  />
                )}
                control={control}
                rules={{
                  required: {
                    value: true,
                    message: t("body.vehYearRequired"),
                  },
                }}
              />
            </Grid>
            <Grid
              style={{ maxWidth: "300px", width: "100%" }}
              size={vehicleFieldSize}
            >
              <Controller
                name="vehMake"
                control={control}
                rules={{
                  required: {
                    value: true,
                    message: t("body.vehMakeRequired"),
                  },
                }}
                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    id="vehMake"
                    style={{ maxWidth: 300, width: "100%" }}
                    options={vehicleMakesList}
                    getOptionLabel={(option) => option.label}
                    isOptionEqualToValue={(option, value) =>
                      value.label === option.label
                    }
                    disabled={submitting}
                    onChange={(_, data) => {
                      field.onChange(data);
                      setValue("vehModel", null);
                      setVehModelList([]);
                      setVehicleTrimLists([]);
                      setValue("vehTrim", null);

                      if (data === null) {
                        setCurrentMakeId();
                      } else {
                        setCurrentMakeId(data.code);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        label={t("body.vehMakeLabel")}
                        placeholder={t("body.vehMakePlaceholder")}
                        variant="outlined"
                        error={!!errors.vehMake}
                        helperText={
                          errors.vehMake ? errors.vehMake.message : ""
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  />
                )}
              />
            </Grid>
            <Grid
              style={{ maxWidth: "300px", width: "100%" }}
              size={vehicleFieldSize}
            >
              <Controller
                name="vehModel"
                control={control}
                rules={{
                  required: {
                    value: true,
                    message: t("body.vehModelRequired"),
                  },
                }}
                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    id="vehModel"
                    style={{ maxWidth: 300, width: "100%" }}
                    options={vehModelList}
                    disabled={
                      currentMakeId < 1 ||
                      vehModelList.length === 0 ||
                      submitting
                    }
                    getOptionLabel={(option) => option?.vehicleModelName || ""}
                    isOptionEqualToValue={(option, value) =>
                      value?.vehicleModelName === option?.vehicleModelName
                    }
                    onChange={(_, data) => {
                      field.onChange(data);
                      setSelectedVehicleModel(data);
                      setValue("vehTrim", null);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        label={t("body.vehModelLabel")}
                        placeholder={t("body.vehModelPlaceholder")}
                        variant="outlined"
                        error={!!errors.vehModel}
                        helperText={
                          errors.vehModel ? errors.vehModel.message : ""
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  />
                )}
              />
            </Grid>

            {isISAVehicle && vehicleTrimLists?.length > 0 && (
              <Grid
                style={{ maxWidth: "300px", width: "100%" }}
                size={vehicleFieldSize}
              >
                <Controller
                  name="vehTrim"
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: t("location.trimLevelRequired"),
                    },
                  }}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      id="vehTrim"
                      style={{ maxWidth: 300, width: "100%" }}
                      options={vehicleTrimLists ?? []}
                      disabled={!selectedVehicleModel || submitting}
                      getOptionLabel={(option) =>
                        option?.vehicleTrimDescription || ""
                      }
                      isOptionEqualToValue={(option, value) =>
                        value?.vehicleTrimID === option?.vehicleTrimID
                      }
                      onChange={(_, data) => {
                        field.onChange(data);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          label={t("location.trimLevel")}
                          placeholder={t("location.trimLevelPlaceholder")}
                          variant="outlined"
                          error={!!errors.vehTrim}
                          helperText={
                            errors.vehTrim ? errors.vehTrim.message : ""
                          }
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      )}
                    />
                  )}
                />
              </Grid>
            )}

            <Grid
              style={{ maxWidth: "300px", width: "100%" }}
              size={vehicleFieldSize}
            >
              <Controller
                name="engineClassId"
                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    style={{ maxWidth: 300, width: "100%" }}
                    id="engineClassId"
                    options={[...(filterEngineClass ?? [])].sort((a, b) =>
                      (a?.label ?? "").localeCompare(b?.label ?? ""),
                    )}
                    getOptionLabel={(option) => option?.label}
                    isOptionEqualToValue={(option, value) => {
                      return option?.code === value?.code;
                    }}
                    disabled={submitting}
                    onChange={(_, data) => field.onChange(data)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        label={t("steps.engType")}
                        placeholder={t("body.selectEngineTypeLabel")}
                        variant="outlined"
                        error={!!errors.engineClassId}
                        helperText={
                          errors.engineClassId
                            ? errors.engineClassId.message
                            : ""
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  />
                )}
                control={control}
                rules={{
                  required: {
                    value: true,
                    message: t("steps.engTypeRequired"),
                  },
                }}
              />
            </Grid>

            {!isISAVehicle && (
              <>
                <Grid
                  container
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    gap: "20px",
                    maxWidth: "543px",
                    flexDirection: "row",
                    ...(isSpeedStory
                      ? {
                          "@media (max-width:924px)": {
                            flexDirection: "column",
                          },
                        }
                      : isScheduleStory
                        ? {
                            "@media (max-width:972px)": {
                              flexDirection: "column",
                            },
                          }
                        : {
                            "@media (max-width:1004px)": {
                              flexDirection: "column",
                            },
                          }),
                  }}
                >
                  {(storyName?.toLowerCase() === "location" ||
                    isEuropeStory) && (
                    <Grid
                      size={{
                        xs: 12,
                      }}
                      sx={{
                        width: "100%",
                        maxWidth: isMobile ? "275px" : "543px",
                        textAlign: "left",
                      }}
                    >
                      <Typography sx={{ py: "8px", maxWidth: "275px" }}>
                        {isEuropeStory
                          ? t("europe.whatFeatures")
                          : t("location.whatFeatures")}
                      </Typography>
                    </Grid>
                  )}
                  <Grid
                    style={{ maxWidth: "255px", width: "100%" }}
                    size={{ xs: 12, sm: 6 }}
                  >
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <Grid sx={{ width: "100%" }}>
                        <Grid
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <FormControlLabel
                            sx={{
                              gap: 1,
                              color: `${brandColors[brand].primary}`,
                            }}
                            control={
                              <Checkbox
                                checked={checkedPush}
                                onChange={(e) =>
                                  setCheckedPush(e.target.checked)
                                }
                                sx={{ p: 0 }}
                                disabled={submitting}
                              />
                            }
                            label={t("steps.pushStartLevel")}
                          />

                          <Grid>
                            {isTouchDevice ? (
                              <ClickAwayListener
                                onClickAway={() => setShowTooltip(false)}
                              >
                                <div>
                                  <Tooltip
                                    placement="left-start"
                                    open={showTooltip}
                                    disableFocusListener
                                    disableHoverListener
                                    disableTouchListener
                                    title={
                                      <div
                                        style={{
                                          position: "relative",
                                          display: "inline-block",
                                        }}
                                      >
                                        <img
                                          src={KeylessStart}
                                          alt="Keyless Start"
                                          style={{ display: "block" }}
                                        />
                                        {showCrossButton ? (
                                          <IconButton
                                            size="small"
                                            onClick={() =>
                                              setShowTooltip((prev) => !prev)
                                            }
                                            sx={{
                                              position: "absolute",
                                              top: 0,
                                              right: 0,
                                              padding: "2px",
                                              borderRadius: 0,
                                              border: "0.1px solid #fff",
                                              boxShadow: 1,
                                              backgroundColor: "#d1495b",
                                              color: "#fff",
                                              "&:hover": {
                                                backgroundColor: "#b82f41",
                                              },
                                            }}
                                          >
                                            <CloseIcon fontSize="small" />
                                          </IconButton>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    }
                                  >
                                    <IconButton
                                      aria-label="info"
                                      onClick={() => {
                                        handleOpenTooltip();
                                      }}
                                      size="large"
                                      sx={{
                                        "& .MuiSvgIcon-root": {
                                          fill: `${brandColors[brand].primary}`,
                                          fontSize: "1.9rem",
                                        },
                                        p: 0,
                                      }}
                                    >
                                      <HelpIcon />
                                    </IconButton>
                                  </Tooltip>
                                </div>
                              </ClickAwayListener>
                            ) : (
                              <Tooltip
                                placement="top"
                                title={
                                  <div
                                    style={{
                                      position: "relative",
                                      display: "inline-block",
                                    }}
                                  >
                                    <img
                                      src={KeylessStart}
                                      alt="Keyless Start"
                                      style={{ display: "block" }}
                                    />
                                    {showCrossButton ? (
                                      <IconButton
                                        size="small"
                                        onClick={() =>
                                          setShowTooltip((prev) => !prev)
                                        }
                                        sx={{
                                          position: "absolute",
                                          top: 0,
                                          right: 0,
                                          padding: "2px",
                                          borderRadius: 0,
                                          boxShadow: 1,
                                          border: "0.1px solid #fff",
                                          backgroundColor: "#d1495b",
                                          color: "#fff",
                                          "&:hover": {
                                            backgroundColor: "#b82f41",
                                          },
                                        }}
                                      >
                                        <CloseIcon fontSize="small" />
                                      </IconButton>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                }
                              >
                                <IconButton
                                  aria-label="info"
                                  size="large"
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      fill: `${brandColors[brand].primary}`,
                                      fontSize: "1.9rem",
                                    },
                                    p: 0,
                                  }}
                                >
                                  <HelpIcon />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Grid>
                        </Grid>
                        <Typography sx={{ fontSize: "12px", opacity: "60%" }}>
                          {t("steps.pushStartMessage")}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid
                    style={{ maxWidth: "255px", width: "100%" }}
                    size={{ xs: 12, sm: 6 }}
                  >
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <Grid sx={{ width: "100%" }}>
                        <Grid
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <FormControlLabel
                            sx={{
                              gap: 1,
                              color: `${brandColors[brand].primary}`,
                            }}
                            control={
                              <Checkbox
                                checked={checkedRemote}
                                onChange={(e) =>
                                  setCheckedRemote(e.target.checked)
                                }
                                sx={{ p: 0 }}
                                disabled={submitting}
                              />
                            }
                            label={t("steps.remoteStart")}
                          />

                          <Grid>
                            {isTouchDevice ? (
                              <ClickAwayListener
                                onClickAway={() => setShowTooltipRemote(false)}
                              >
                                <div>
                                  <Tooltip
                                    placement="left-start"
                                    open={showTooltipRemote}
                                    disableFocusListener
                                    disableHoverListener
                                    disableTouchListener
                                    title={
                                      <div
                                        style={{
                                          position: "relative",
                                          display: "inline-block",
                                        }}
                                      >
                                        <img
                                          src={RemoteStart}
                                          alt="Remote Start"
                                          style={{ display: "block" }}
                                        />
                                        {showCrossButtonRemote ? (
                                          <IconButton
                                            size="small"
                                            onClick={() =>
                                              setShowTooltipRemote(
                                                (prev) => !prev,
                                              )
                                            }
                                            sx={{
                                              position: "absolute",
                                              top: 0,
                                              right: 0,
                                              padding: "2px",
                                              borderRadius: 0,
                                              boxShadow: 1,
                                              border: "0.1px solid #fff",
                                              backgroundColor: "#d1495b",
                                              color: "#fff",
                                              "&:hover": {
                                                backgroundColor: "#b82f41",
                                              },
                                            }}
                                          >
                                            <CloseIcon fontSize="small" />
                                          </IconButton>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    }
                                  >
                                    <IconButton
                                      aria-label="info"
                                      onClick={() => {
                                        handleOpenRemoteTooltip();
                                      }}
                                      size="large"
                                      sx={{
                                        "& .MuiSvgIcon-root": {
                                          fill: `${brandColors[brand].primary}`,
                                          fontSize: "1.9rem",
                                        },
                                        p: 0,
                                      }}
                                    >
                                      <HelpIcon />
                                    </IconButton>
                                  </Tooltip>
                                </div>
                              </ClickAwayListener>
                            ) : (
                              <Tooltip
                                placement="top"
                                title={
                                  <div
                                    style={{
                                      position: "relative",
                                      display: "inline-block",
                                    }}
                                  >
                                    <img
                                      src={RemoteStart}
                                      alt="Remote Start"
                                      style={{ display: "block" }}
                                    />
                                    {showCrossButtonRemote ? (
                                      <IconButton
                                        size="small"
                                        onClick={() =>
                                          setShowTooltipRemote((prev) => !prev)
                                        }
                                        sx={{
                                          position: "absolute",
                                          top: 0,
                                          right: 0,
                                          padding: "2px",
                                          borderRadius: 0,
                                          boxShadow: 1,
                                          border: "0.1px solid #fff",
                                          backgroundColor: "#d1495b",
                                          color: "#fff",
                                          "&:hover": {
                                            backgroundColor: "#b82f41",
                                          },
                                        }}
                                      >
                                        <CloseIcon fontSize="small" />
                                      </IconButton>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                }
                              >
                                <IconButton
                                  aria-label="info"
                                  size="large"
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      fill: `${brandColors[brand].primary}`,
                                      fontSize: "1.9rem",
                                    },
                                    p: 0,
                                  }}
                                >
                                  <HelpIcon />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Grid>
                        </Grid>
                        <Typography sx={{ fontSize: "12px", opacity: "60%" }}>
                          {t("steps.remoteStartMessage")}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}

            {isEuropeStory && (
              <Grid
                container
                justifyContent="center"
                spacing={2}
                sx={{ mt: 1, mb: 2 }}
              >
                <Grid
                  size={{ xs: 12, md: 12 }}
                  sx={{
                    width: "100%",
                    maxWidth: { xs: "300px", md: "100%" },
                    textAlign: { xs: "left", md: "inherit" },
                  }}
                >
                  <Typography sx={{ fontWeight: 700, fontSize: 18 }}>
                    {t("europe.vehicleRegistration")}
                  </Typography>
                </Grid>
                <Grid
                  size={{ xs: 12, md: 6 }}
                  sx={{ width: "100%", maxWidth: "300px" }}
                >
                  <Controller
                    name="issuingCountry"
                    control={control}
                    rules={{
                      required: t("europe.registrationCountryRequired"),
                    }}
                    render={({ field }) => (
                      <Autocomplete
                        sx={{ width: "100%", maxWidth: "300px" }}
                        options={europeRegistrationCountries}
                        value={field.value}
                        loading={registrationCountriesLoading}
                        getOptionLabel={(option) => option?.label || ""}
                        isOptionEqualToValue={(option, value) =>
                          String(option?.regionId) === String(value?.regionId)
                        }
                        onChange={(_, value) => field.onChange(value)}
                        disabled={submitting || registrationCountriesLoading}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            label={t("europe.registrationCountry")}
                            placeholder={t("europe.selectRegistrationCountry")}
                            error={!!errors.issuingCountry}
                            helperText={errors.issuingCountry?.message || ""}
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                      />
                    )}
                  />
                </Grid>
                <Grid
                  size={{ xs: 12, md: 6 }}
                  sx={{ width: "100%", maxWidth: "300px" }}
                >
                  <Controller
                    name="licensePlate"
                    control={control}
                    rules={{
                      required: t("europe.registrationNumberRequired"),
                      validate: (value) =>
                        Boolean(value?.trim()) ||
                        t("europe.registrationNumberRequired"),
                    }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        sx={{ maxWidth: "300px" }}
                        size="small"
                        disabled={submitting}
                        label={t("europe.registrationNumber")}
                        placeholder={t("europe.enterRegistrationNumber")}
                        InputLabelProps={{ shrink: true }}
                        error={!!errors.licensePlate}
                        helperText={errors.licensePlate?.message || ""}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            )}

            <Grid style={{ width: "100%" }}>
              <Grid
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <ContinueButton
                  goToBackStep={goToBackStep}
                  submitting={submitting}
                  showForwardIcon={isEuropeStory ? false : true}
                  isLongWidth={isSpeedStory ? true : false}
                />
              </Grid>
            </Grid>
          </Grid>
        </form>
      )}
    </>
  );
};

VehicleInfos.propTypes = {
  onChange: PropTypes.func,
  loadVehicle: PropTypes.func,
  handleUpdate: PropTypes.func,
  goToNextStep: PropTypes.func,
  goToBackStep: PropTypes.func,
  vehicleList: PropTypes.array,
  submitting: PropTypes.bool,
  loadVehicleTrim: PropTypes.func,
  deviceType: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    vehicleList: state.vehicle,
  };
}

const mapDispatchToProps = {
  loadVehicle,
  loadVehicleTrim,
};

export default connect(mapStateToProps, mapDispatchToProps)(VehicleInfos);
